/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import CommonModal from '../../../components/Modal';

export default function InvoiceScheduledModal({ open, onClose, removeParams, studentCount, transactionId, isBulkIssueTriggered, isOngoingTermExists }) {
    // const [invoiceScheduledModalOpen, setInvoiceScheduledModalOpen] = useState(false);
    const handleOnClick = () => {
        onClose();
        removeParams();
        if(!transactionId || transactionId === 'undefined' || transactionId === null || transactionId === 'null') return;
        window.open(`/student-master/invoice-list/bulk-invoice-history/invoice-issue-status?transaction_id=${transactionId}`, '_blank', 'noopener,noreferrer');
    };

    return (
        <CommonModal
            show={open}
            handleClose={onClose}
            title={(isBulkIssueTriggered && isBulkIssueTriggered === 'true') ? "Fee Structure updated. Invoice issuing scheduled." : "Fee Structure updated"}
        >
            <div className="-mt-3 mb-4 w-[700px] " >
                {isOngoingTermExists && isOngoingTermExists === 'false' ?
                    <div className="text-center mb-4 mt-4">
                        <span>Fee Structure updated successfully.</span><br /><br />
                        <span className="text-red-500 mt-3">No invoices were issued since there are no ongoing terms.</span>
                    </div>

                    :  (isBulkIssueTriggered && isBulkIssueTriggered === 'true') ? (
                        <div className="text-center mb-4 mt-4">
                            <span>Fee Structure updated successfully.</span><br /><br />
                            <span className="font-medium">Invoice issuing is scheduled for {studentCount} student{studentCount > 1 ? 's' : ''}.</span><br />
                            Check <span
                                onClick={handleOnClick}
                                className="text-[#106EB4] underline font-medium cursor-pointer"
                            >
                                Invoice Issue Status
                            </span> page for more details.
                        </div>
                    ) : (
                        <div className="text-center mb-4 mt-4">
                            <span>Fee Structure updated successfully.</span><br /><br />
                            <span className="text-red-500 mt-3">However, an error occurred while scheduling invoices for ongoing terms.<br></br> Please issue them manually.</span>
                        </div>
                    )
                }

                <div className="flex justify-center">
                    <button
                        className="actn-btn1"
                        onClick={handleOnClick}
                        type="button"
                    >
                        OK
                    </button>
                </div>
            </div>
        </CommonModal>
    );
} 